<div class="container">
    <div class="header"></div>
    <div class="title">Protected area...!</div>
    <div class="message">{{ message }}</div>
    <div class="actions">
        <ng-content select=".actions"></ng-content>
    </div>
</div>
